export const MAX_MAP_MARKERS = 10000;

export const TOOLTIP_STYLE = {
  contentStyle: {
    background: 'hsl(20 15% 12%)',
    border: '1px solid hsl(20 50% 30% / 0.3)',
    borderRadius: '8px',
    color: '#e5e5e5',
    fontSize: '13px',
  },
};

export const GRID_STROKE = 'hsl(20 10% 20%)';
export const AXIS_TICK = { fill: '#999', fontSize: 11 };
